export const isValidUrl = (value: string): boolean => {
  try {
    new URL(value.startsWith("http") ? value : `https://${value}`);
    return value.length > 0;
  } catch {
    return false;
  }
};

export const getUrlOrigin = (url: string): string => {
  try {
    const fullUrl = url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
    return new URL(fullUrl).origin;
  } catch {
    return "";
  }
};

const IGNORED_PARAMS = new Set([
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "gclid",
  "gclsrc",
  "dclid",
  "msclkid",
  "zanpid",
]);

export function getSchemelessUrl(inputUrl: string): string {
  try {
    const urlToParse = inputUrl.match(/^https?:\/\//i) ? inputUrl : `https://${inputUrl}`;
    const urlObj = new URL(urlToParse);

    let hostname = urlObj.hostname.toLowerCase();
    if (hostname.startsWith("www.")) {
      hostname = hostname.slice(4);
    }

    const pathname = urlObj.pathname.toLowerCase();

    const params = new URLSearchParams(urlObj.search);
    const sortedParams: string[] = [];

    params.forEach((value, key) => {
      if (!IGNORED_PARAMS.has(key.toLowerCase())) {
        sortedParams.push(`${key}=${value}`);
      }
    });

    sortedParams.sort();

    let result = `${hostname}${pathname}`;

    if (sortedParams.length > 0) {
      result += `?${sortedParams.join("&")}`;
    }

    if (result.endsWith("/") && sortedParams.length === 0) {
      result = result.slice(0, -1);
    }

    return result;
  } catch {
    return inputUrl.toLowerCase().replace(/^https?:\/\/(www\.)?/i, "");
  }
}
